<template>
    <div>
        <div class="search-wrap">
            <div class="search">
                <div class="search-hot">
                    <p class="title">搜索热词：</p>
                    <p
                        class="hot-word"
                        v-for="(item, i) in hotList"
                        :key="i"
                        :class="{'blue':currentHot == item.id}"
                        @click="hotSearch(item)"
                    >{{item.name}}</p>
                </div>
                <div class="flex-x">
                    <el-input v-model="content" placeholder="请输入搜索的内容" />
                    <el-button type="primary" icon="el-icon-search" @click="textSearch">站内搜索</el-button>
                </div>
            </div>
        </div>
        <div
            class="article-list"
            id="main-container"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
        >
            <el-container>
                <el-aside>
                    <p class="title">首页/站内搜索</p>
                    <div class="option">
                        <ul class="art-class select-type">
                            <div class="title">按文章类别</div>
                            <li
                                v-for="(item, i) in classList"
                                :class="{'blue':currentType == item.id}"
                                :key="i"
                                @click="selectType(item.id)"
                            >{{item.label}}</li>
                        </ul>
                        <ul class="time select-type">
                            <div class="title">按发布时间</div>
                            <li
                                v-for="(item, i) in timeList"
                                :class="{'blue':currentTime == item.id}"
                                :key="i"
                                @click="selectTime(item.id)"
                            >{{item.name}}</li>
                        </ul>
                    </div>
                </el-aside>
                <el-main>
                    <p class="result">找到{{total}}条相关结果</p>
                    <div class="expert-wrap">
                        <div
                            v-for="single in expertList"
                            :key="single.id"
                            v-show="expertList.length > 0"
                        >
                            <single-article :single="single"></single-article>
                        </div>
                    </div>
                    <el-pagination
                        v-if="total>0"
                        background
                        layout="jumper, prev, pager, next, slot, total"
                        :total="total"
                        :current-page="page"
                        @current-change="currentChange"
                        @prev-click="prevClick"
                        @next-click="nextClick"
                    >
                        <!-- <span class="el-pagination__total"> 共 {{ pageCount }} 页，</span> -->
                    </el-pagination>
                </el-main>
            </el-container>
        </div>
    </div>
</template>

<script>
    import SingleArticle from '../../components/common/SingleArticle';
    export default {
        components: {
            SingleArticle
        },
        props: {},
        data() {
            return {
                search: '',
                total: 0,
                label: '',
                expertList: [],
                hotList: [],
                loading: false,
                content: '',
                classList: [],
                currentTime: '',
                currentType: '',
                currentHot: '',
                timeList: [
                    {
                        name: '全部',
                        id: 'all'
                    },
                    {
                        name: '最近一周',
                        id: 'week'
                    },
                    {
                        name: '最近一月',
                        id: 'month'
                    },
                    {
                        name: '最近半年',
                        id: 'halfyear '
                    },
                    {
                        name: '最近一年',
                        id: 'year'
                    }
                ],
                page: 1,
                size: 10
            };
        },
        computed: {
            pageCount() {
                let count = 0;
                let total = Number(this.total);
                if (total) {
                    if (total % 10 === 0) {
                        count = total / 10;
                    } else {
                        count = Math.floor(total / 10) + 1;
                    }
                }
                return count;
            }
        },
        created() {
            if (this.$route.query.name) {
                this.content = this.$route.query.name;
            }
            this.page = 1;
            this.getNavList();
            this.getHotWords();
            this.getArticleList();
        },
        mounted() {},
        watch: {
            '$route.query.name': function(val) {
                this.content = val;
                this.expertList = [];
                this.page = 1;
                this.getArticleList();
            }
        },
        methods: {
            getHotWords() {
                this.httpGet(this.$root.getHotWords)
                    .then(res => {
                        this.hotList = res;
                        this.loading = false;
                    })
                    .catch(err => {
                        this.loading = false;
                        console.error('getNavList-err', err);
                    });
            },
            selectType(id) {
                this.page = 1;
                this.currentType = id;
                this.getArticleList();
            },
            selectTime(id) {
                this.page = 1;
                this.currentTime = id;
                this.getArticleList();
            },
            getNavList() {
                this.httpGet(this.$root.getNavList)
                    .then(res => {
                        this.classList = res.list;
                        console.log(2222, this.classList);
                        this.loading = false;
                    })
                    .catch(err => {
                        this.loading = false;
                        console.error('getNavList-err', err);
                    });
            },
            hotSearch(item) {
                this.page = 1;
                this.currentTime = '';
                this.currentType = '';
                this.content = item.name;
                this.currentHot = item.id;
                this.expertList = [];
                this.getArticleList();
            },
            textSearch() {
                this.page = 1;
                this.currentTime = '';
                this.currentType = '';
                this.expertList = [];
                this.getArticleList();
            },
            getArticleList() {
                this.loading = true;
                this.httpGet(this.$root.stationSearch, {
                    date: this.currentTime,
                    class: this.currentType,
                    content: this.content,
                    page: this.page,
                    size: this.size
                })
                    .then(result => {
                        if (result.count) {
                            this.expertList.push(...result.list);
                            this.total = Number(result.count);
                        } else {
                            this.expertList = [];
                            this.total = 0;
                        }
                        this.loading = false;
                    })
                    .catch(err => {
                        this.loading = false;
                        console.error('expertList-err', err);
                    });
            },
            currentChange(page) {
                this.page = page;
                this.expertList = [];
                this.getArticleList();
            },
            prevClick(page) {
                this.page = page;
                this.expertList = [];
                this.getArticleList();
            },
            nextClick(page) {
                this.page = page;
                this.expertList = [];
                this.getArticleList();
            }
        }
    };
</script>

<style lang='stylus' rel='stylesheet/stylus' scoped>
    @import '~assets/main.styl';

    .blue {
        color: #197DFF !important;
    }

    .flex-x {
        flex-x();
    }

    .flex-left {
        flex-x(flex-start);
    }

    #main-container {
        // min-height: 520px;
        margin-top: 20px;
    }

    .expert-wrap {
        // min-height: 520px;
        margin-top: 15px;
        border-radius: 8px;
        overflow: hidden;
    }

    #main-container {
        .title {
            margin-bottom: 10px;
        }

        .result {
            margin-bottom: 10px;
            font-size: 12px;
            color: gray6;
        }
    }

    .el-main {
        padding: 0 20px;
    }

    >>>.el-pagination {
        width: 860px;
        flex-center();
        padding: 20px;
        box-sizing: border-box;
        background: white;
        margin-top: 20px;
    }

    .search-wrap {
        width: 100%;
        background: white;
        height: 180px;
        flex-center();
        padding: 40px;
        box-sizing: border-box;
    }

    .search {
        width: 740px;

        .search-bot {
            margin-top: 10px;

            p {
                margin-right: 10px;
                color: gray9;
            }
        }

        .search-hot {
            flex-x(flex-start);
            margin-bottom: 10px;

            .hot-word {
                cursor: pointer;
            }

            .title {
                color: gray3;
            }

            p {
                color: gray9;
                margin-right: 30px;
            }
        }
    }

    .option {
        .select-type {
            width: 100%;
            background: white;
            border-radius: 8px;
            padding: 16px;
            box-sizing: border-box;
            margin-bottom: 20px;

            li {
                height: 40px;
                line-height: 40px;
                padding-left: 20px;
                box-sizing: border-box;
                cursor: pointer;
                font-size: 14px;
            }

            .title {
                height: 40px;
                width: 100%;
                background: #F0F5FA;
                line-height: 40px;
                padding-left: 20px;
                box-sizing: border-box;
                position: relative;
                font-size: 14px;
                font-weight: bold;

                &::before {
                    content: '';
                    position: absolute;
                    top: 10px;
                    left: 0;
                    width: 4px;
                    height: 20px;
                    background: #4093FF;
                }
            }
        }
    }
</style>
